import { ClickAwayListener } from "@mui/material";
import { FC, useState } from "react";
import { useTranslation } from "react-i18next";

import { PIC, SVG_MUI } from "@ryde/assets";
import { FramerTooltip } from "@ryde/controls";
import {
  onActivateKeyDown,
  RideStatusEnum,
  TOOLTIP_DELAY_BUTTONS,
  TPermissionAction,
} from "@ryde/shared";

import { RidesEditStatusDropdownItem } from "./rides-edit-status-dropdown-item";
import { RideEditStatusDropdownStyled } from "./rides.panels.styled";

const availableEditStatusPermission = new Set<{
  status: RideStatusEnum;
  permission: TPermissionAction;
}>([
  { status: RideStatusEnum.Rejected, permission: "reject" },
  { status: RideStatusEnum.Canceled, permission: "cancel" },
  { status: RideStatusEnum.Approved, permission: "approve" },
  { status: RideStatusEnum.New, permission: "create" },
  { status: RideStatusEnum.Received, permission: "mark_as_received" },
  { status: RideStatusEnum.Done, permission: "mark_as_done" },
  { status: RideStatusEnum.DoneApproved, permission: "mark_as_done_approved" },
]);

export const RidesEditStatusDropdown: FC = () => {
  const [isEditStatusSelectOpen, setIsEditStatusSelectOpen] = useState(false);

  const { t } = useTranslation();

  const toggleEditStatusSelect = (): void => {
    setIsEditStatusSelectOpen(!isEditStatusSelectOpen);
  };

  const closeEditStatusSelect = (): void => setIsEditStatusSelectOpen(false);

  return (
    <RideEditStatusDropdownStyled>
      <FramerTooltip
        content={t("general.CHANGE_STATUS")}
        rtlStrippedBottomRightPlacement
        tooltipDisabled={isEditStatusSelectOpen}
        mouseEnterDelay={TOOLTIP_DELAY_BUTTONS}
      >
        <div
          className="edit_status_button"
          onClick={toggleEditStatusSelect}
          onKeyDown={onActivateKeyDown(toggleEditStatusSelect)}
          role="button"
          tabIndex={0}
        >
          <SVG_MUI.CancelSVG className="edit_status_icon" />
          <span>{t("general.CHANGE_STATUS")}</span>
          <span className="arrow_icon">
            <PIC.FilledArrowSvg />
          </span>
        </div>
      </FramerTooltip>

      {isEditStatusSelectOpen && (
        <ClickAwayListener onClickAway={closeEditStatusSelect}>
          <div
            className="edit_status_select"
            onMouseLeave={closeEditStatusSelect}
          >
            {Array.from(availableEditStatusPermission).map(option => (
              <RidesEditStatusDropdownItem key={option.status} {...option} />
            ))}
          </div>
        </ClickAwayListener>
      )}
    </RideEditStatusDropdownStyled>
  );
};
